<template>
  <TreeViewRoot
    :items="items"
    :parent="parent"
    :opened="opened"
    :on-change-open="onChangeOpen"
    :identifier="identifier"
    :on-create="onCreate"
    :on-save="onSave"
    :on-delete="onDelete"
    :refresh-tree="refreshTree"
    :get-items="getItems"
  />
</template>

<script>
export default {
  name: "TreeViewItem",
  components: {
    TreeViewRoot: () => import('./TreeViewRoot.vue')
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    parent: {
      type: [Number, String],
      default: null
    },
    identifier: {
      type: Number,
      default: 0
    },
    opened: {
      type: Array,
      default: () => {
        return []
      }
    },
    onChangeOpen: {},
    onCreate: {},
    onSave: {},
    onDelete: {},
    refreshTree: {},
    getItems: {},
  }
}
</script>
